import React from 'react'
import DateTimeField from 'react-bootstrap-datetimepicker'
import StaticTextComponent from './StaticTextComponent'
import CurrencyComponent from './CurrencyComponent'
import PasswordComponent from './PasswordComponent'
import {t} from '../../helpers/translate'
import moment from 'moment';
import BaseInputComponent from './BaseInputComponent'
import { Input, Button } from 'react-bootstrap'
const config = require('config');
const util = require('util');


class TextComponent extends BaseInputComponent {
  parseDate(props) {
    if (!props) return;
    if (props === 'today') return moment();
    if (props.base) {
      const baseDate = this.getKeyPathValue(props.base);
      return moment(baseDate).add(...props.offset.split(' '));
    }
    return moment(props);
  }

  getInputBox() {
    switch (this.props.format) {
      case 'date':
        if (this.props.isStatic) return <StaticTextComponent id={this.props.id} value={this.getValue()} />;
        const dateFormat = 'YYYY-MM-DD';
        const maxDate = this.parseDate(this.props.maxDate);
        const minDate = this.parseDate(this.props.minDate);

        return <DateTimeField mode="date" size="md" inputFormat={dateFormat} format={dateFormat}
                              dateTime={moment(this.getValue()).format(dateFormat)} defaultText={this.getValue() ? this.getValue(): ''}
                              onChange={this.handleChange.bind(this)} maxDate={maxDate} minDate={minDate}
                              inputProps={{id: this.props.id, placeholder: 'YYYY-MM-DD'}}
        />;

      case 'currency':
        const keyPath = this.getKeyPathValue(['search', 'currency']) ? this.getKeyPathValue(['search', 'currency']) : this.getKeyPathValue(['application', 'currency']);
        return <CurrencyComponent
          {...this.props}
          id={this.props.id}
          value={this.getValue()}
          currency={keyPath}
          onChange={(event) => { this.handleChange(event.target.value) }}
        />;

      case 'password':
        return <PasswordComponent {...this.props} />

      case 'textarea':
        return <textarea name="comments" id="comments" rows="8" className="form-control textarea required" cols="80" onChange={(event) => { this.handleChange(event.target.value) }} />

      case 'multivalue':
        const values = this.getValue() || [];
        return <div>{values.join(', ')}</div>

      case 'tugo_checkbox':
        const rawValue = this.getValue();
        
        if (!rawValue) return <div className="text-muted">—</div>;

        const options = this.props.options || [];
        const checkedItems = options.filter(opt => {
          const isSelected = typeof rawValue.get === 'function' 
            ? rawValue.get(opt.value) 
            : rawValue[opt.value];
            
          return isSelected === true;
        }).map(opt => opt.text);

        return (
          <div>
            {checkedItems.map(text => t(text)).join(', ')}
          </div>
        );

      case 'link':
        return <a target="_blank" href={this.getValue()}>{t('Open Form')}</a>

      case 'percentage':
        const value = this.getValue() ? this.getValue() : 0
        if (this.props.isStatic) {
          return <StaticTextComponent id={this.props.id} value={`${value}%`} />;
        }
        return <Input
          id={this.props.id}
          type='number'
          minValue='0'
          maxValue='100'
          defaultValue={value}
          onChange={(event) => { this.handleChange(event.target.value) }}
        />

      default:
        if (this.props.isStatic) return <StaticTextComponent id={this.props.id} value={this.getValue()}/>;
        return <Input
          id={this.props.id}
          type='text'
          defaultValue={this.getValue()}
          onChange={(event) => { this.handleChange(event.target.value) }}
        />
    }
  }

  render() {
    return <div className={this.state.isInvalid ? 'has-error form-group' : 'form-group'}>
      {this.getInputBox()}
    </div>

  }
}


export default TextComponent;



// WEBPACK FOOTER //
// ./src/components/common/TextComponent.js